import React, { useMemo, useState } from "react";
import { X, CalendarDays } from "lucide-react";
import { it } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import MemoGiorno, { isoGiorno } from "./MemoGiorno";

const chiave = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

// Calendario: quante email per giorno, e la lista di quel giorno con apertura diretta
export default function CalendarioModal({ open, onClose, emails, onOpenEmail, memo = [], accounts = [], onMemoChange }) {
  const [giorno, setGiorno] = useState(new Date());
  const perGiorno = useMemo(() => {
    const m = {};
    for (const e of emails || []) {
      if (!e.ts || e.folder === "eliminate" || e.folder === "bozze") continue;
      const k = chiave(new Date(e.ts * 1000));
      (m[k] = m[k] || []).push(e);
    }
    for (const k in m) m[k].sort((a, b) => (b.ts || 0) - (a.ts || 0));
    return m;
  }, [emails]);
  if (!open) return null;
  const lista = perGiorno[chiave(giorno)] || [];
  const conEmail = (d) => (perGiorno[chiave(d)] || []).length > 0;
  const conMemo = (d) => memo.some((m) => m.data === isoGiorno(d) && !m.fatto);

  return (
    <div className="wf-modal-backdrop show" onClick={onClose} data-testid="calendario-backdrop">
      <div className="wf-modal calendario-modal modal-leggero" onClick={(e) => e.stopPropagation()} data-testid="calendario-modal">
        <div className="wf-modal-head">
          <span className="wf-modal-title"><CalendarDays size={19} strokeWidth={2.3} /> Calendario</span>
          <button className="icon-btn" onClick={onClose} aria-label="Chiudi" data-testid="calendario-close"><X size={20} strokeWidth={2.6} /></button>
        </div>
        <div className="calendario-body">
          <Calendar
            mode="single"
            locale={it}
            selected={giorno}
            onSelect={(d) => d && setGiorno(d)}
            modifiers={{ conEmail, conMemo }}
            modifiersClassNames={{ conEmail: "cal-con-email", conMemo: "cal-con-memo" }}
            data-testid="calendario-picker"
          />
          <div className="calendario-lista" data-testid="calendario-lista">
            <MemoGiorno giorno={giorno} memo={memo} accounts={accounts} onChange={onMemoChange} />
            <div className="calendario-lista-title">
              {giorno.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" })} · {lista.length} email
            </div>
            {lista.length === 0 && <div className="manu-text">Nessuna email in questo giorno.</div>}
            {lista.slice(0, 60).map((e) => (
              <button key={e.id} className="calendario-item" onClick={() => { onOpenEmail(e.id); onClose(); }} data-testid={`calendario-item-${e.id}`}>
                <span className="cal-dot" style={{ background: e.colore || "#122a44" }} />
                <span className="cal-ora">{e.ora}</span>
                <span className="cal-mitt">{e.folder === "inviate" ? `A: ${e.a || e.email}` : e.mittente}</span>
                <span className="cal-ogg">{e.oggetto}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
